var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylegisIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.755,
    height: 91.194,
    viewBox: "0 0 94.755 91.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_355",
    "data-name": "Caminho 355",
    d: "M146.927,90.1H89.474a12.827,12.827,0,0,0-12.881,12.881v52.545a12.918,12.918,0,0,0,1.431,25.762h46.821a12.827,12.827,0,0,0,12.881-12.881V116.066h9.2a12.983,12.983,0,0,0,0-25.966Zm-46.412,20.65a7.156,7.156,0,1,1,14.312,0v13.9a7.156,7.156,0,1,1-14.312,0Zm15.948,67.266H78.843a9.2,9.2,0,0,1,0-18.4h37.62A13.341,13.341,0,0,0,116.463,178.016Zm-6.134-36.8v3.476h1.636a2.658,2.658,0,0,1,0,5.316h-8.383a2.658,2.658,0,1,1,0-5.316h1.636v-3.476a16.505,16.505,0,0,1-13.9-16.357,2.658,2.658,0,0,1,5.316,0,11.45,11.45,0,1,0,22.9,0,2.658,2.658,0,0,1,5.316,0A18.261,18.261,0,0,1,110.329,141.214Zm38.642-29.237h0V107.07a1.832,1.832,0,0,0-1.84-1.84h-9.2v-2.045a9.2,9.2,0,1,1,11.041,8.792Z",
    transform: "translate(-65.058 -90.1)",
    fill: "#dbb200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylegisIcon);
export default __webpack_public_path__ + "static/media/playlegis-icon.b4a124198098913bd07886242cc1ad55.svg";
export { ForwardRef as ReactComponent };